import {FC, useContext} from 'react'
import {GlobalContext} from './ctx/GlobalContext'

type ICallbackFunction = (sortCol: string) => void

const FundTableHeaderCell: FC<{
    handleDataSort: ICallbackFunction
    val: string
    label: string
    className: string
    ctxSortCol: any
    ctxSortDir: any
}> = ({handleDataSort, val, label, className, ctxSortCol, ctxSortDir}) => {
    const globalCtx = useContext(GlobalContext)

    return (
        <>
            <div className={className} onClick={() => handleDataSort(val)}>
                {globalCtx.layout !== 'ofe' ? (
                    <>
                        <span className="filter-arrow flex">
                            <span
                                className={
                                    'arrow-up' + (ctxSortCol === val && ctxSortDir === 'DESC' ? ' arrow-inactive' : '')
                                }></span>
                            <span
                                className={
                                    'arrow-down' + (ctxSortCol === val && ctxSortDir === 'ASC' ? ' arrow-inactive' : '')
                                }></span>
                        </span>
                    </>
                ) : (
                    ''
                )}
                <span className="font-sort">{label}</span>
            </div>
        </>
    )
}

export default FundTableHeaderCell
